import React from 'react';
import { withRouter } from 'react-router';
import { Helmet } from 'react-helmet-async';
import LoginSection, { LoginProps } from '../components/LoginSection';
import { Link } from 'react-router-dom';
import useGtmEventTracking from '../components/useGtmEventTracking';
import { useFlow } from '../utilities/useFlow';

interface LoginComponentProps extends LoginProps {}

function LoginComponent(props: LoginComponentProps): JSX.Element {
  const sendDataToGTM = useGtmEventTracking();
  const flow = useFlow();

  const handleRegisterClick = () => {
    sendDataToGTM({ event: 'register_link' });
  };

  return (
    <>
      <Helmet>
        <title>{`Login | ${flow}`}</title>
        <meta name="description" content={`Log in to your ${flow} account to manage your storage, shipping, and removals orders.`} />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <section className="login-status-bar">
        <div className="status-bar-content">
          <span>Not a customer?</span>
          <Link onClick={handleRegisterClick} to="/register">
            Register here
          </Link>
        </div>
      </section>
      <LoginSection {...props} />
      You may need to login twice
    </>
  );
}

export default withRouter(LoginComponent);
